import { UiState, Snackbar } from './state'
import { ActionContext } from 'vuex'

export const openSnackbar = function (context: ActionContext<UiState, object>, snackbar: Snackbar): void {
  context.commit('setSnackbar', snackbar)
}

export const closeSnackbar = function (context: ActionContext<UiState, object>): void {
  const snackbar = context.getters.getSnackbar

  if (snackbar.callback) {
    snackbar.callback()
  }

  context.commit('setSnackbar', {
    active: false,
    message: '',
    link: '',
    buttonText: '',
    callback: undefined
  })
}
